import React, { useState, useEffect, FC } from 'react';
import ModalLogout from '../../Main/Modals/ModalLogout/ModalLogout';

import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { tehnoSkyOperatorLogo, userIcon } from '../../../assets/icons';

import classes from './MainHeader.module.scss';

type MainHeaderProps = {
  setIsAuthenticated: (status: boolean) => void;
  setWorkPlaceSelected: (status: boolean) => void;
  workplaceName?: string | null;
  workplaceDescription?: string | null;
  setWorkplaceName?: (value: string | null) => void;
  setWorkplaceDescription?: (value: string | null) => void;
};

const MainHeader: FC<MainHeaderProps> = ({
  setIsAuthenticated,
  setWorkPlaceSelected,
  workplaceName,
  workplaceDescription,
  setWorkplaceName,
  setWorkplaceDescription
}) => {
  const [activeLogout, setActiveLogout] = useState(false);
  const [time, setTime] = useState<string>(format(Date.now(), 'HH:mm'));
  const [date, setDate] = useState<string>(format(Date.now(), 'dd MMMM yyyy', { locale: ru }));
  const user = JSON.parse(localStorage.getItem('user'));

  const handleLogout = () => {
    setActiveLogout(true);
  };

  useEffect(() => {
    // На случай обновления страницы — подтягиваем сохранённое рабочее место.
    if (workplaceName !== undefined || workplaceDescription !== undefined) return;
    const raw = localStorage.getItem('workplace');
    if (!raw) return;
    try {
      const parsed = JSON.parse(raw) ?? {};
      const name = (parsed?.name as string | undefined) ?? null;
      const description = (parsed?.description as string | undefined) ?? null;
      setWorkplaceName?.(name);
      setWorkplaceDescription?.(description);
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      setTime(format(now, 'HH:mm'));
      setDate(format(now, 'dd MMMM yyyy', { locale: ru }));
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <div className={classes.headerContainer}>
        <div>
          <img src={tehnoSkyOperatorLogo} alt="logo" />
        </div>
        <div className={classes.timeContainer}>
          <span className={classes.time}>{time}</span>
          <span className={classes.date}>{date}</span>
        </div>

        <div className={classes.logoContainer} onClick={() => handleLogout()}>
          <div className={classes.userInfo}>
            <span className={classes.username}>{user && user.fullName}</span>
            {(workplaceName || workplaceDescription) && (
              <div className={classes.workplaceInfo}>
                {workplaceName && <span className={classes.workplaceName}>{workplaceName}</span>}
                {workplaceDescription && (
                  <span className={classes.workplaceDescription}>{workplaceDescription}</span>
                )}
              </div>
            )}
          </div>
          <img src={userIcon} alt="userIcon" />
        </div>
        <ModalLogout
          setIsAuthenticated={setIsAuthenticated}
          setActiveLogout={setActiveLogout}
          setWorkPlaceSelected={setWorkPlaceSelected}
          activeLogout={activeLogout}
        />
      </div>
    </div>
  );
};

export default MainHeader;
